// Modal.js

import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Spell } from "../../Types/TableTypes";

interface SpellViewDetailProps{
    spell: Spell,
    closeModal: ()=> void

}

const SpellModalView = (props: SpellViewDetailProps) => {
    const backgroundaRef = useRef<HTMLDivElement>(null);
    const { t } = useTranslation();
    
    return (
        <>
            <div className="modal" tabIndex={-1} style={{display: "block"}}>
                <div 
                    ref={backgroundaRef}
                    className="modal-background"
                    tabIndex={-1} role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" 
                    onClick={e=>{
                        if(e.target === backgroundaRef.current)
                        {
                            props.closeModal(); 
                        }
                    }}>
                    <div className="modal-dialog" style={{maxWidth: "75%"}}>
                        <div className="modal-content">
                            <div className="modal-header ps-4 pe-4">
                                <h4 className="modal-title ps-4 pe-4">{props.spell.name}</h4>
                                <button type="button" className="btn-close ps-4 pe-4" onClick={e=>props.closeModal()} aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                {/* <div className="d-flex flex-wrap text-center">
                                    <div className="col-3 p-2">
                                        <div><b>{t("spellmodal-level")}</b></div>
                                        <div>{props.spell.level}</div>
                                    </div>
                                    <div className="col-3 p-2">
                                        <div><b>{t("spellmodal-castingtime")}</b></div>
                                        <div>{props.spell.castingTime}</div>
                                    </div>
                                    <div className="col-3 p-2">
                                        <div><b>{t("spellmodal-rangearea")}</b></div>
                                        <div>{props.spell.range? props.spell.range.mt+"m "+props.spell.range.sq+t("sq") : ""}</div>
                                    </div>
                                    <div className="col-3 p-2">
                                        <div><b>{t("spellmodal-components")}</b></div>
                                        <div>{props.spell.components}</div>
                                    </div>
                                    <div className="col-3 p-2">
                                        <div><b>{t("spellmodal-duration")}</b></div>
                                        <div>{props.spell.duration}</div>
                                    </div>
                                    <div className="col-3 p-2">
                                        <div><b>School</b></div>
                                        <div>{props.spell.school}</div>
                                    </div>
                                    <div className="col-3 p-2">
                                        <div><b>{t("spellmodal-attacksave")}</b></div>
                                        <div>{props.spell.attackType+props.spell.dc? props.spell.dc.type : ""}</div>
                                    </div>
                                    <div className="col-3 p-2">
                                       <div><b>{t("spellmodal-damageeffect")}</b></div>
                                        <div>{props.spell.damage? props.spell.damage.type : ""}</div>
                                    </div>
                                </div> */}
                                <div className="pt-2 pb-2 ps-4 pe-4">
                                    <div>
                                        Level {props.spell.level} {props.spell.school} ({props.spell.classes /*+ (props.spell.subclasses ? ", "+props.spell.subclasses : "")*/})
                                    </div>
                                    {props.spell.concentration && 
                                        <div>
                                            <b>{t("spellmodal-concentration")}:</b>
                                        </div>
                                    }
                                    <div>
                                        <b>{t("spellmodal-castingtime")}:</b>&nbsp;{props.spell.castingTime}
                                    </div>
                                    <div>
                                        <b>{t("spellmodal-range")}:</b>&nbsp;{(props.spell.range.ft > 0 ? props.spell.range.mt+"m "+props.spell.range.sq+"sq " : "")+props.spell.otherRange}
                                    </div>
                                    <div>
                                        <b>{t("spellmodal-components")}:</b>&nbsp;{""+(props.spell.components.v?"V ":"") + (props.spell.components.s?"S ":"") + (props.spell.components.m?"M ":"") + (props.spell.materials? " ("+props.spell.materials+")" : "")}
                                    </div>
                                    <div>
                                        <b>{t("spellmodal-duration")}:</b>&nbsp;{props.spell.duration}
                                    </div>
                                </div>
                                <div className="pt-2 pb-2 ps-4 pe-4">
                                    {props.spell.description ? props.spell.description.split('\n').map((subStr) => {
                                        return (
                                        <>
                                            {subStr}
                                            <br />
                                        </>
                                        );}) : ""
                                    }
                                </div>
                                <div className="pt-2 pb-4 ps-4 pe-4">
                                    {props.spell.higherLevel ? props.spell.higherLevel.split('\n').map((subStr) => {
                                        return (
                                        <>
                                            <b>{t("spellmodal-athigherlevel")}</b><br/>
                                            {subStr}
                                            <br />
                                        </>
                                        );}) : ""
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SpellModalView;
